export default __webpack_public_path__ + "static/media/Asset 15.9fb86566.png";